import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    center: { lat: 4.5720763, lng: -74.1342726 },
    radius: 500,
    markers: [],
    points: [],
    locationUser: { lat: 0, lng: 0 },
    marketSelect: { lat: 0, lng: 0 },
    travelMode : 'DRIVING',
    dialog: {
      activate: false,
      message: ''
    },
    directions: {
      distance : 'calculando...',
      duration : 'calculando...',
      steps : [],
      end_address : 'calculando...',
      start_address : 'calculando...',
      travelMode : 'DRIVING'
    }
  },
  mutations: {
    setCenter (state, center) {
      state.center = center
    },
    setRadius (state, radius) {
      state.radius = radius
    },
    setMarker (state, marker) {
      state.markers.push(marker)
    },
    cleanMarkers (state) {
      for(let i=0; i < state.markers.length; i++){
        state.markers[i]["visibility"] = false;
      }
      state.markers = [];
    },
    setPoints (state, points) {
      state.points = points
    },
    setLocationUser (state, locationUser) {
      state.locationUser = locationUser
    },
    setMarketSelect (state, marketSelect) {
      state.marketSelect = marketSelect
    },
    setDialog (state, dialog) {
      state.dialog = dialog
    },
    setDirections (state, direction) {
      state.directions = direction
    },
    setTravelMode (state, mode) {
      state.travelMode = mode
    }  
  },
  actions: {
    addCenter: ({commit}, center) => {
      commit('setCenter', center)
    },
    addRadius: ({commit}, radius) => {
      commit('setRadius', radius)
    },
    addMarker: ({commit}, obj) => {
           
      const marker = {
        position: obj,
        visibility: true
      }
      commit('setMarker', marker)
    },
    addPoints: ({commit}, points) => {
      commit('setPoints', points)
    },
    addLocationUser: ({commit}, locationUser) => {
      commit('setLocationUser', locationUser)
    },
    addMarketSelect: ({commit}, markerSelect) => {
      commit('setMarketSelect', markerSelect)
    },
    addDialog: ({commit}, text) => {
      let obj = {
        activate: true,
        message: text
      }
      commit('setDialog', obj)
    },
    addDirections: ({commit}, direction) => {
      commit('setDirections', direction)
    },
    addTravelMode: ({commit}, mode) => {
      commit('setTravelMode', mode)
    },
    selectCard: ({commit, state}, index) => {
      var points = state.points;
      points[index].select = true;
      for(let i = 0; i < points.length; i++){
        if(index != i){
          points[i].select = false
        }
      }
      commit('setPoints', points)
    },
    closeCards: ({commit, state}) => {
      var points = state.points
      for(let i = 0; i < points.length; i++){
        points[i].select = false
      }
      commit('setPoints', points)
    },
  },
  getters: {
    getCenter: (state) => {
        return state.center
    },
    getRadius: (state) => {
      return state.radius
    },
    getMarkers: (state) => {
      return state.markers
    },
    getPoints: (state) => {
      return state.points
    },
    getLocationUser: (state) => {
      return state.locationUser
    },
    getMarketSelect: (state) => {
      return state.marketSelect
    },
    getDialog: (state) => {
      return state.dialog
    },
    getDirections: (state) => {
      return state.directions
    },
    getTravelMode: (state) => {
      return state.travelMode
    }
  }
})

export default store;